export default __webpack_public_path__ + "static/media/Group 4.747b0a0f.svg";